/**
 * Where the live sockets live.
 *
 * The one call (`assistant-live-wire.ts`) and dictation (`dictation-wire.ts`)
 * both hang their routes off this base. It is pure and sits apart from the
 * files that reach for `apiBaseUrl`, which pulls React Native in and cannot be
 * loaded by a test.
 */

/** ws for http, wss for https, as the events socket does. */
export const liveWsUrl = (base: string): string => `${base.replace(/^http/, 'ws')}/v1/agent/live`;
